import React, { createContext, useCallback, useState, useContext } from 'react';
import api from '../services/api';
import { config } from '../config/msAuth';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [data] = useState(() => {
    const token = localStorage.getItem('accessToken');
    const userName = localStorage.getItem('userName');
    const userEmail = localStorage.getItem('userEmail');
    const scopes = localStorage.getItem('scopes');
    const comanagementId = localStorage.getItem('comanagementId');
    const comanagementsIds = localStorage.getItem('comanagementsIds');
    const businessUnitsIds = localStorage.getItem('businessUnitsIds');
    const userId = localStorage.getItem('userId');
    const officeId = localStorage.getItem('officeId');

    if (
      !!token &&
      token !== 'undefined' &&
      !!userName &&
      userName !== 'undefined' &&
      !!userEmail &&
      userEmail !== 'undefined' &&
      !!scopes &&
      scopes !== 'undefined' &&
      !!comanagementId &&
      comanagementId !== 'undefined' &&
      !!comanagementsIds &&
      comanagementsIds !== 'undefined' &&
      !!businessUnitsIds &&
      businessUnitsIds !== 'undefined'
    ) {
      return {
        token,
        user: {
          userName,
          userEmail,
          scopes: JSON.parse(scopes),
          comanagementId,
          comanagementsIds: JSON.parse(comanagementsIds),
          businessUnitsIds: JSON.parse(businessUnitsIds),
          userId,
          officeId,
        },
      };
    }

    return {};
  });

  const handleSignIn = useCallback(async accessToken => {
    try {
      const { data } = await api.post(
        '/auth/signin',
        {
          scopes: ['scheduling'],
        },
        {
          headers: { Authorization: 'Bearer ' + accessToken },
        },
      );

      localStorage.setItem('accessToken', 'Bearer ' + data.accessToken);
      localStorage.setItem('userEmail', data.email || data.userPrincipalName);
      localStorage.setItem('userName', data.displayName);
      localStorage.setItem('scopes', JSON.stringify(data.scopes));
      localStorage.setItem('comanagementId', data.comanagementId);
      localStorage.setItem(
        'comanagementsIds',
        JSON.stringify(data.comanagementsIds),
      );
      localStorage.setItem(
        'businessUnitsIds',
        JSON.stringify(data.businessUnitsIds),
      );
      localStorage.setItem('userId', data.professionalId);
      localStorage.setItem('officeId', data.officeId);
    } catch (err) {
      throw new Error(err);
    }
  }, []);

  const handleSignInMicrosoft = useCallback(from => {
    localStorage.setItem('from', from);
    const baseUri = `https://login.microsoftonline.com/${config.tenantId}/oauth2/v2.0`;

    const uriPieces = {
      client_id: config.clientId,
      response_type: 'token',
      redirect_uri: config.redirectUri,
      scope: config.scopes,
      response_mode: 'fragment',
      nonce: config.nonce,
      prompt: 'select_account',
    };

    const params = new URLSearchParams(uriPieces).toString();
    const url = `${baseUri}/authorize?${params}`;

    window.location.href = url;
  }, []);

  const isAuthenticated = useCallback(() => {
    const accessToken = localStorage.getItem('accessToken');

    return !!accessToken;
  }, []);

  const hasScope = useCallback(
    scopes => {
      return data.user && data.user.scopes.some(x => scopes.includes(x));
    },
    [data.user],
  );

  return (
    <AuthContext.Provider
      value={{
        user: data.user,
        redirectMicrosoft: handleSignInMicrosoft,
        signInAuthorize: handleSignIn,
        isAuthenticated,
        hasScope,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
